import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { withValue } from '@g4/automation-hooks';

import { Box, useMedia, Text, VerticalSpacing } from './Boneyard';
import Breadcrumb from './Breadcrumb';
import ContinueButton from '../components/ContinueButton';

const propTypes = {
  automationHook: PropTypes.string,
  displayBreadcrumb: PropTypes.bool,
  title: PropTypes.string,
  onContinueClick: PropTypes.func,
  showContinueButton: PropTypes.bool,
  disableContinueButton: PropTypes.bool,
  displayPageTitle: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export const PageTitle = withTheme(({ title, theme, automationHook }) => {
  const mq = useMedia();

  return (
    <h1>
      <Text
        size={mq.lt('sm') ? 20 : 35}
        weight={600}
        color={theme.colors.pageHeading.title}
        automationHook={withValue(automationHook, 'page-heading')}
      >
        {title}
      </Text>
    </h1>
  );
});

const PageHeading = ({
  displayBreadcrumb = true,
  title,
  automationHook,
  onContinueClick,
  disableContinueButton,
  showContinueButton,
  displayPageTitle,
  backgroundColor,
}) => {
  const mq = useMedia();

  return (
    <>
      {displayBreadcrumb && !mq.lt('md') && (
        <Breadcrumb backgroundColor={backgroundColor} />
      )}
      {title !== displayPageTitle && <VerticalSpacing size={4} />}

      <Box
        d="flex"
        alignItems="center"
        justifyContent={title ? 'space-between' : 'flex-end'}
      >
        {title && title !== displayPageTitle && (
          <PageTitle title={title} automationHook={automationHook} />
        )}
        {displayBreadcrumb && mq.lt('md') && (
          <Breadcrumb compact backgroundColor={backgroundColor} />
        )}
        {showContinueButton && (
          <ContinueButton
            automationHook={automationHook}
            onSubmit={onContinueClick}
            fullWidth={mq.lte('sm')}
            isDisabled={disableContinueButton}
          />
        )}
      </Box>
    </>
  );
};

PageHeading.propTypes = propTypes;

export default PageHeading;
